import { ChevronLeft } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../utils/api";
import "./ReportDetails.css";

const ReportDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [student, setStudent] = useState({
    grNo: "-",
    section: "-",
    name: "-",
    class: "-",
    transactions: [],
    total: 0,
  });

  const fetchStudent = async () => {
    const response = await api.get(`/feesreport/${id}`);
    setStudent((prev) => ({
      ...prev,
      grNo: response.data.gr,
      class: response.data.class,
      section: response.data.section,
      name: response.data.name,
    }));
  };
  
  const fetchFeeSetup = async () => {
    const response = await api.get(`/feessetup/details/${id}`);
    const transactions = Array.isArray(response.data) ? response.data : [];
    setStudent((prev) => ({
      ...prev,
      transactions,
      total: transactions.reduce((sum, item) => sum + Number(item.total), 0)
    }));
  };

  useEffect(() => {
    fetchStudent();
    fetchFeeSetup();
  }, []);

  return (
    <div className="details-container" style={{ padding: "25px" }}>
      <button className="back-button" onClick={() => navigate("/fee_report")}>
        <ChevronLeft /> Back
      </button>
      <div className="report-container">
        <h2 className="report-title">Student Fees Report Details</h2>
        <div className="student-info">
          <div>
            <strong>GR No:</strong> {student.grNo}
          </div>
          <div>
            <strong>Section:</strong> {student.section}
          </div>
          <div>
            <strong>Name:</strong> {student.name}
          </div>
          <div>
            <strong>Class:</strong> {student.class}
          </div>
        </div>
        <h3 className="transaction-title">Fees Details</h3>
        <table className="transaction-table">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Month</th>
              <th>Status</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {student.transactions.map((item, idx) => (
              <tr key={idx}>
                <td>{idx + 1}.</td>
                <td>{item.month}</td>
                <td>{item.status}</td>
                <td className="amount">{item.total}</td>
              </tr>
            ))}
            <tr className="total-row">
              <td colSpan={3}>
                <strong>Total Amount (₹):</strong>
              </td>
              <td className="amount">
                <strong>{student.total.toFixed(2)}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportDetails;
